export default __webpack_public_path__ + "static/media/nalsoft.855022ad.png";